import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const imagesApi = createApi({
  reducerPath: 'imagesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/',
    prepareHeaders: (headers) => {
      // Remove Content-Type header to let the server determine the response type
      return headers;
    },
    responseHandler: async (response) => {
      const contentType = response.headers.get('content-type');
      if (contentType?.includes('application/json')) {
        return response.json();
      } else if (contentType?.includes('image/svg+xml') || contentType?.includes('text/xml')) {
        return response.text();
      }
      return response.text();
    }
  }),
  endpoints: (builder) => ({
    getImage: builder.query<string, string>({
      query: (id) => {
        return `images/${id}.svg`;
      },
      transformResponse: (response: string) => {
        console.log('Raw API Response:', response);
        return response;
      },
      transformErrorResponse: (response: any) => {
        console.error('API Error:', response);
        return response;
      }
    }),
  }),
});

export const { useGetImageQuery } = imagesApi;
